module.exports = __webpack_public_path__ + "img/Dots_Light.0f14695d.svg";